export const PAYMENT_MONTHLY_CONTAINER_QUERY_KEY =
  'MarketplacePaymentClient.getMonthsContainerMarketplacePayments';
export const PAYMENT_SINGLE_MONTH_QUERY_KEY =
  'MarketplacePaymentClient.getMarketplacePayments';
